import hostyAppIcon from '@assets/images/hosty-app-icon.png';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useStaffAuth } from '../../context/StaffAuthContext';
import { usePanelMenu } from '../../hooks/usePanelMenu';
import { Button } from '../ui/Button';
import { PanelMobileHeader } from './PanelMobileHeader';
import './layouts.css';
import '../../pages/staff/staff.css';

const navItems = [
  { to: '/staff', label: 'Disponibles', end: true },
  { to: '/staff/mis-tickets', label: 'Mis tickets' },
  { to: '/staff/cobros-pendientes', label: 'Cobros pendientes' },
  { to: '/staff/ganancias', label: 'Ganancias' },
  { to: '/staff/referidos', label: 'Referidos' },
  { to: '/staff/manual', label: 'Manual' },
];

export function StaffLayout() {
  const { user, logout } = useStaffAuth();
  const navigate = useNavigate();
  const { open, toggle, close } = usePanelMenu();

  async function handleLogout() {
    await logout();
    navigate('/staff/login');
  }

  const brand = (
    <Link to="/" className="brand brand--panel">
      <img src={hostyAppIcon} alt="" className="brand__mark" width={32} height={32} />
      <span>
        Hosty <strong>Staff</strong>
      </span>
    </Link>
  );

  return (
    <div className="staff-layout">
      <PanelMobileHeader brand={brand} open={open} onToggle={toggle} />
      <button
        type="button"
        className={`panel-menu-overlay ${open ? 'is-open' : ''}`}
        aria-label="Cerrar menú"
        onClick={close}
        tabIndex={open ? 0 : -1}
      />
      <aside className={`staff-sidebar ${open ? 'is-open' : ''}`}>
        {brand}
        <nav className="staff-nav">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className="staff-nav__link">
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="panel-sidebar__footer">
          <div className="panel-user">
            <strong>
              {user?.name} {user?.surname}
            </strong>
            <span>{user?.email}</span>
          </div>
          <Button variant="ghost" size="sm" onClick={handleLogout}>
            Cerrar sesión
          </Button>
        </div>
      </aside>
      <main className="staff-main">
        <Outlet />
      </main>
    </div>
  );
}
